<template>
  <div class="match">
    <div id="mapContainer" class="map-control">我是地图</div>
  </div>
</template>
<script>
import getData from "../service/getData";
import api from "../service/api";
import getColor from "../service/randomColor.js";
import moment from "moment";
import coordUtil from "../service/coordUtil.js";

let osmurl =
  "https://webrd04.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}";
//   "http://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineStreetGray/MapServer/tile/{z}/{y}/{x}";
export default {
  data: function() {
    return {
      show: true,
      cityList: [],
      dataList: [],
      userData: {},
      levelKey: "mingxiWeight",
      selectUser: null,
      pointsAll: {},
      lineMap: new Map(), //每一条线路的信息
      colorMap: new Map(), //用来保存一个人一个月的颜色
      dateMap: new Map(), //用来保存日期和数组对应(i,2018-09-01)
      layerMap: new Map() //用来存储每一天的数据
    };
  },
  mounted() {
    this.map = L.map("mapContainer", {
      center: [39.908701, 116.397481],
      zoom: 10,
      minZoom: 1,
      maxZoom: 18,
      projection: L.Projection.LonLat,
      attributionControl: false,
      zoomControl: false
    });
    L.tileLayer(osmurl).addTo(this.map);
    L.control
      .zoom({
        position: "bottomright",
        zoomInTitle: "放大",
        zoomOutTitle: "缩小"
      })
      .addTo(this.map);
    L.control
      .scale({
        imperial: false
      })
      .addTo(this.map);
    this.addLine();
  },
  methods: {
    addLine: async function() {
      const latLngsBais = [
        [22.733438641365, 114.07100001253],
        [22.733120470113, 114.07131277927],
        [22.73317518682, 114.07123440645],
        [22.733186754672, 114.07121244322],
        [22.733189988356, 114.07120756194],
        [22.733196461607, 114.07119915457]
      ];
      const latLngsGaos = [];

      for (let latLng of latLngsBais) {
        latLngsGaos.push(coordUtil.bd09togcj02(latLng.reverse()).reverse());
      }

      const color = getColor.getColor();
      let layers = [];
      layers.push(
        L.polyline(latLngsGaos, {
          color: color
        })
        // .bindPopup(attrRoute.join("<br>"))
      );

      const featureGroup = L.featureGroup(layers);
      featureGroup.addTo(this.map);
      this.map.fitBounds(featureGroup.getBounds());
      this.layerMap.set(fileName, featureGroup);
    },
    getFileData: async function(fileName) {
      console.log("输出" + fileName);
      const res = await getData.get(api.softFileData, {
        type: "unOrder",
        fileName
      });
      if (res.data && res.data.status) {
        let layers = [];
        const color = getColor.getColor();

        for (let i = 0; i < res.data.allDatas.length; i++) {
          let itemData = res.data.allDatas[i];
          const divHtml = `<div class='way-points' style='background-color:${color}'>${i +
            1}</div>`;
          const wayDivIcon = new L.divIcon({
            html: divHtml,
            className: "leaflet-direction-icon"
          });
          const attrMarker = [];
          attrMarker.push("名称:" + ["机构名称"]);
          attrMarker.push(
            "到达时间:" +
              (res.unOrder ? itemData.arrvieTime : itemData["签入时间"])
          );
          attrMarker.push(
            "离开时间:" +
              (res.unOrder ? itemData.arrvieTime : itemData["签出时间"])
          );
          attrMarker.push("在店时长（分钟）:" + itemData["在店时长（分钟）"]);
          attrMarker.push("代表:" + itemData["代表"]);
          attrMarker.push("权重:" + itemData["权重属性"]);

          layers.push(
            L.marker([itemData.Latitude, itemData.Longitude], {
              icon: wayDivIcon
              // draggable: true
            }).bindPopup(attrMarker.join("<br>"))
          );
        }
        const latLngs = [];
        const routes = res.data.pathString.split(";");
        for (let route of routes) {
          latLngs.push(route.split(",").reverse());
        }
        layers.push(
          L.polyline(latLngs, {
            color: color
          })
          // .bindPopup(attrRoute.join("<br>"))
        );

        const featureGroup = L.featureGroup(layers);
        featureGroup.addTo(this.map);
        this.map.fitBounds(featureGroup.getBounds());
        this.layerMap.set(fileName, featureGroup);
      }
    },
    choiceUser(user) {
      for (let layersGroup of this.layerMap.values()) {
        layersGroup.remove();
      }
      this.layerMap.clear();
    }
  }
};
</script>
<style lang="less">
.match {
  width: 100%;
  height: 100%;
}
.map-control {
  width: 100%;
  height: calc(~"100% - 36px");
}
</style>


// WEBPACK FOOTER //
// src/components/MineDemo.vue